import { BreadcrumbsInterface } from "@/components/PageCluster/types/breadcrumbs";
import routes from "@/helpers/router";

export const generateBreadcrumbs = (clusterDetails) => {
  const breadCrumbs: [BreadcrumbsInterface] = [
    {
      label: clusterDetails?.Category?.data?.attributes?.CategoryName,
      url: routes.category(clusterDetails?.Category?.data?.attributes?.Slug),
    },
  ];

  if (clusterDetails?.Pillar?.data?.attributes?.Name) {
    const pillarName = clusterDetails?.Pillar?.data?.attributes?.Name;
    breadCrumbs.push({
      label: pillarName,
      url: routes.pillar(clusterDetails?.Pillar?.data?.attributes?.Slug),
    });
  }

  breadCrumbs.push({
    label: clusterDetails?.Name,
    url: routes.cluster(clusterDetails?.Slug),
  });

  return breadCrumbs;
};
